module.exports = __webpack_public_path__ + "img/work_icon_training.75568f9a.svg";